import { gql } from 'apollo-angular';

export const CREATE_ADS_MUTATION = gql`
  mutation createAds($createAdsInput: CreateAdsInput!) {
    createAds(createAdsInput: $createAdsInput) {
      adsId
      audience
      dateCreated
      dateUpdated
      description
      isSponsor
      link
      photo
      publishedDate
      sponsor
      status
      subTitle
      title
    }
  }
`;

export const UPDATE_ADS_MUTATION = gql`
  mutation UpdateAds($adsId: HashedId!, $updateAdsInput: UpdateAdsInput!) {
    updateAds(adsId: $adsId, updateAdsInput: $updateAdsInput) {
      adsId
      audience
      dateCreated
      dateUpdated
      description
      isSponsor
      link
      photo
      publishedDate
      sponsor
      status
      subTitle
      title
    }
  }
`;
